import { env } from '@/env'
import { orderXAiClient } from '@/service/ai-client'
import {
  ChatRequest,
  ChatResponse,
  ChatStatus,
  GetSessionResponse,
  ListSessionsResponse,
} from '@/types/generated/chat_api'

const isDevEnv = env.NEXT_PUBLIC_ENV === 'dev'

export const sendChatMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  if (isDevEnv) {
    return {
      sessionId: '',
      status: ChatStatus.CHAT_STATUS_ERROR,
      executionBatch: undefined,
      warnings: [],
      triggeredItems: [],
      refusals: [],
      choices: undefined,
      message: 'AI chat is not available in dev mode',
    }
  }
  const response = await orderXAiClient.post<ChatResponse>('/v1/chat', request)
  return response.data
}

export const getSession = async (sessionId: string): Promise<GetSessionResponse> => {
  if (isDevEnv) return { session: undefined }
  const response = await orderXAiClient.get<GetSessionResponse>(`/v1/sessions/${sessionId}`, {
    _responseDecoder: (bytes: Uint8Array) => GetSessionResponse.decode(bytes),
  })
  return response.data
}

export const listSessions = async (limit = 20, offset = 0): Promise<ListSessionsResponse> => {
  if (isDevEnv) return { sessions: [] }
  const response = await orderXAiClient.get<ListSessionsResponse>('/v1/sessions', {
    params: { limit, offset },
    _responseDecoder: (bytes: Uint8Array) => ListSessionsResponse.decode(bytes),
  })
  return response.data
}

export interface ReportFlagRequest {
  session_id: string
  turn_sk: string
  source: string
  type: string
  notes: string
}

export interface ReportFlagResponse {
  id?: string
  url?: string
  triage_item_id?: string
  triage_item_url?: string
}

export const reportFlag = async (
  request: ReportFlagRequest
): Promise<ReportFlagResponse | undefined> => {
  const response = await orderXAiClient.post<ReportFlagResponse>('/v1/flags', request, {
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
  return response.data
}
